import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type PaymentMethodId = 'mobile_money' | 'card';

export interface PaymentMethodOption {
  id: PaymentMethodId;
  gateway: string;
  label: string;
  currency: string;
  available: boolean;
}

interface PaymentMethodsResult {
  methods: PaymentMethodOption[];
}

/**
 * Payment methods the checkout can offer (availability flags come from the
 * backend gateway configuration).
 */
export function usePaymentMethods() {
  return useQuery({
    queryKey: ['payments', 'methods'],
    queryFn: () => api.get<PaymentMethodsResult>('/payments/methods'),
    select: (res) => res.data.methods,
    staleTime: 5 * 60 * 1000,
  });
}
